export default (client) => {
  const root = '/user_messages'

  return {
    /**
     * @param {object} MessagesDTO
     * @param {string} MessagesDTO.lang
     *
     * @returns {Promise<Response<UserMessageResponse>>}
     * */
    list({ lang }) {
      const url = `${root}/list`
      const params = {
        length: '',
        start: 0,
        lang,
      }

      return client.get(url, { params })
    },

    /**
     * @param {object} ReadMessageDTO
     * @param {string} ReadMessageDTO.uuid
     *
     * @returns {Promise<Response<MessageActionResponse>>}
     * */
    markAsRead({ uuid }) {
      const url = `${root}/mark_read`

      return client.post(url, { uuid })
    },

    /**
     * @param {object} RemoveMessageDTO
     * @param {string} RemoveMessageDTO.uuid
     *
     * @returns {Promise<Response<MessageActionResponse>>}
     * */
    remove({ uuid }) {
      const url = `${root}/remove`

      return client.post(url, { uuid })
    },
  }
}

/**
 * @typedef {Object} UserMessage
 * @property {string} uuid
 * @property {1 | 0} is_new
 * @property {string} subject
 * @property {string} message
 * @property {string} type
 * @property {string} created_date - `YYYY-MM-DD HH:mm:ss` format
 * */

/**
 * @typedef {Object} UserMessageResponse
 * @property {boolean} status
 * @property {number} total_count
 * @property {UserMessage[]} data
 * */

/**
 * @typedef {Object} MessageActionResponse
 * @property {boolean} status
 * @property {number} new_messages
 */
